import React from 'react';
import "./assets/App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from './Home';
import SignIn from './auth/SignIn';
import SignUp from './auth/SignUp';
import { AuthProvider } from './auth/Authentication';
import PrivateRoute from './PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div>
          <PrivateRoute exact path="/" component={Home} />
          <Route exact path="/signin" component={SignIn} />
          <Route exact path="/signup" component={SignUp} />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
